import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class FormaPago extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'forma-pago/one', saveUrl: 'forma-pago/save', backUrl: '/Catalogo/FormasPago' },
      new Form([
        Form.Field('text', 'forma', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'forma_nombre', 'Descripcion', '', [Validators.required], 8),
      ], ['Guardar'], 'Forma de pago'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(FormaPago)
